import React from "react";
import Grid from '@mui/material/Grid';
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import {TextField, Typography} from "@mui/material";
import * as moment from 'moment-timezone';

import {
    ROUNDING_MINUTES_FOR_SHIFT_TIME,
    MOMENT_UNIT_MINUTES,
    ROUNDING_MINUTES_FOR_SHIFT_END_TIME
} from "../../domain/ShiftPlanConstants";

export default function ShiftTimeSelection(props) {

    const {shiftStartTime, setShiftStartTime, shiftEndTime, setShiftEndTime} = props;

    const onKeyDown = (event) => event.preventDefault();

    const handleShiftStartTimeChange = (time) => {
        const roundedEndTime = moment(time)
        .add(ROUNDING_MINUTES_FOR_SHIFT_END_TIME, MOMENT_UNIT_MINUTES)
        .startOf('minute');

        setShiftStartTime(time);

        if (!shiftEndTime || moment(shiftEndTime).isSameOrBefore(time)) {
            setShiftEndTime(roundedEndTime);
        }
    };

    const handleShiftEndTimeChange = (time) => setShiftEndTime(time);

    return (
      <>
          <Grid size={12}>
              <Typography variant="h6">Shift Time</Typography>
          </Grid>
          <Grid size={4}>
              <TimePicker
                ampm={false}
                label="Shift Start Time"
                value={moment(shiftStartTime)}
                onChange={handleShiftStartTimeChange}
                renderInput={params => <TextField {...params} error={false}/>}
                minutesStep={ROUNDING_MINUTES_FOR_SHIFT_TIME}/>
          </Grid>
          <Grid size={1} sx={{marginTop: '1rem', paddingLeft: '0.5rem'}}>
              <Typography variant="body1">to</Typography>
          </Grid>
          <Grid size={4}>
              <TimePicker
                ampm={false}
                label="Shift End Time"
                value={moment(shiftEndTime)}
                onChange={handleShiftEndTimeChange}
                renderInput={params => <TextField {...params} error={false} onKeyDown={onKeyDown}/>}
                minutesStep={ROUNDING_MINUTES_FOR_SHIFT_TIME}/>
          </Grid>
      </>
    );
};